var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "editarInfoStreamax",
      attrs: { row: "", "justify-center": "" }
    },
    [
      _c("v-card", { attrs: { id: "cardDivTV" } }, [
        _c("div", [
          _c(
            "div",
            { staticClass: "cardnew", attrs: { align: "center" } },
            [
              _c("br"),
              _c(
                "v-flex",
                { attrs: { md10: "" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "rounded-card" },
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          staticClass: "col-md-12",
                          attrs: { "lazy-validation": "" },
                          model: {
                            value: _vm.validForm,
                            callback: function($$v) {
                              _vm.validForm = $$v
                            },
                            expression: "validForm"
                          }
                        },
                        [
                          _c(
                            "v-container",
                            { attrs: { "grid-list-md": "" } },
                            [
                              _c(
                                "div",
                                { attrs: { align: "left" } },
                                [
                                  _c("v-flex", { attrs: { md12: "" } }, [
                                    _c(
                                      "h2",
                                      {
                                        staticClass: "h2_title",
                                        staticStyle: {
                                          "margin-top": "12px !important"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.esEdicion
                                                ? "Editar Info Streamax"
                                                : "Ver Detalle Info Streamax"
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                1
                              ),
                              _c("v-divider"),
                              _c("br"),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("p1", { staticClass: "h2_title" }, [
                                        _vm._v("Device Info")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label:
                                            _vm.formFields.serialNumber.label,
                                          disabled: true,
                                          variant: "plain"
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.serialNumber.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.serialNumber,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.serialNumber.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c(
                                        "v-text-field",
                                        {
                                          attrs: {
                                            label:
                                              _vm.formFields.deviceId.label,
                                            disabled: true
                                          },
                                          model: {
                                            value:
                                              _vm.formFields.deviceId.value,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formFields.deviceId,
                                                "value",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formFields.deviceId.value"
                                          }
                                        },
                                        [_vm._v("1~14400 MIN")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("p1", { staticClass: "h2_title" }, [
                                        _vm._v("Vehicle Info")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c(
                                        "v-text-field",
                                        {
                                          attrs: {
                                            label:
                                              _vm.formFields.vehiclePlate.label,
                                            disabled: true
                                          },
                                          model: {
                                            value:
                                              _vm.formFields.vehiclePlate.value,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formFields.vehiclePlate,
                                                "value",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formFields.vehiclePlate.value"
                                          }
                                        },
                                        [_vm._v("1~14400 MIN")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c(
                                        "v-text-field",
                                        {
                                          attrs: {
                                            label:
                                              _vm.formFields.vehicleNum.label,
                                            disabled: true
                                          },
                                          model: {
                                            value:
                                              _vm.formFields.vehicleNum.value,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formFields.vehicleNum,
                                                "value",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formFields.vehicleNum.value"
                                          }
                                        },
                                        [_vm._v("1~14400 MIN")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label:
                                            _vm.formFields.lineNumber.label,
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.lineNumber.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.lineNumber,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.lineNumber.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("p1", { staticClass: "h2_title" }, [
                                        _vm._v("Driver Info")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c(
                                        "v-text-field",
                                        {
                                          attrs: {
                                            label:
                                              _vm.formFields.driverNumber.label,
                                            disabled: true
                                          },
                                          model: {
                                            value:
                                              _vm.formFields.driverNumber.value,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formFields.driverNumber,
                                                "value",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formFields.driverNumber.value"
                                          }
                                        },
                                        [_vm._v("1~14400 MIN")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c(
                                        "v-text-field",
                                        {
                                          attrs: {
                                            label:
                                              _vm.formFields.driverName.label,
                                            disabled: true
                                          },
                                          model: {
                                            value:
                                              _vm.formFields.driverName.value,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formFields.driverName,
                                                "value",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formFields.driverName.value"
                                          }
                                        },
                                        [_vm._v("1~14400 MIN")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }